import React, {FC, ReactNode, memo, useCallback, useContext, useEffect, useState} from 'react';
import {navigate} from 'gatsby';

import CustomModal from '../customModal';
import Footer from './footer';
import ForgotPassword from '../forgot-password';
import Header from './header';
import Login from '../login';
import Registration from '../registration';
import {
  getNewUser,
  getPackageInfo,
  getRawCookie,
  removeDocumentReferrer,
  removeImpactClickIdCookie,
  removeImpactMediaPartnerIdCookie,
  returnDashUrl,
  setDocumentReferrer,
  setImpactClickIdCookie,
  setImpactMediaPartnerIdCookie,
  setNewUser,
} from '../../helpers';
import {UserContext} from '../../contexts/user-context';
import useSetUser from '../../hooks/useSetUser';
import PageHero from './pagehero';
import './styles.scss';

interface LayoutProps {
  children: ReactNode;
  pageheroText?: string;
  pageheroTitle?: any;
  pageheroColor?: string;
  className?: string;
  refetchUser?: boolean;
  refetchHexofyUser?: any;
}
const Layout: FC<LayoutProps> = ({children, pageheroText, pageheroTitle, pageheroColor, className, refetchUser}) => {
  //!---------------State----------------
  //Boolean
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const [handleCloseLoginModal, setHandleCloseLoginModal] = useState(false);
  const [handleCloseRegModal, setHandleCloseRegModal] = useState(false);
  const {user} = useContext(UserContext);
  //String
  const [promoCode, setPromoCode] = useState('');
  const {getUser, loading} = useSetUser();

  //!-----------UseEffects---------------
  useEffect(() => {
    // Setting document referrer
    const referrer =
      typeof document !== 'undefined' &&
      document &&
      document.referrer &&
      document.referrer.indexOf('https://hexofy.com') === -1 &&
      document.referrer;
    if (referrer && getRawCookie('document_referrer')) {
      removeDocumentReferrer();
    }
    referrer && setDocumentReferrer(referrer);
    // Setting Impact irclickid in cookies
    const url = window.location.href;
    if (url && url.indexOf('irclickid=') > -1) {
      if (getRawCookie('__irClickId')) {
        removeImpactClickIdCookie();
      }
      const id = url.slice(url.indexOf('irclickid=') + 10);
      const idFin = id.slice(0, id.indexOf('&'));
      setImpactClickIdCookie(idFin);
      removeImpactMediaPartnerIdCookie();
    } else if (url && url.toLocaleLowerCase().indexOf('mediapartnerid=') > -1) {
      if (getRawCookie('__mediaPartnerId')) {
        removeImpactMediaPartnerIdCookie();
      }
      const id = url.slice(url.toLocaleLowerCase().indexOf('mediapartnerid=') + 15);
      const idFin = id.slice(0, id.indexOf('&'));
      setImpactMediaPartnerIdCookie(idFin);
      removeImpactClickIdCookie();
    }
  }, []);

  useEffect(() => {
    if (window.location.href.includes('PayerID=') || window.location.href.includes('&ba_token=')) {
      // localStorage.setItem('payment_success', 'true');
      window.close();
    }
  }, []);

  useEffect(() => {
    refetchUser && getUser(true);
  }, [refetchUser]);

  useEffect(() => {
    //@ts-ignore
    if (
      global &&
      global.window &&
      global.window.location &&
      global.window.location.hash &&
      global.window.location.hash === '#login' &&
      global.window.location.pathname === '/' &&
      user &&
      !user?.id &&
      !loading
    ) {
      setShowLogin(true);
    }
    // @ts-ignore
    if (
      global &&
      global.window &&
      global.window.location &&
      global.window.location.hash &&
      global.window.location.hash === '#registration' &&
      global.window.location.pathname === '/' &&
      user &&
      !user?.id &&
      !loading
    ) {
      setShowRegistration(true);
    }
    // @ts-ignore
  }, [
    global && global.window && global.window.location && global.window.location.hash && global.window.location.hash,
    user,
    loading,
  ]);
  //!-----------------Functions------------------------
  const closeModal = useCallback(() => {
    if (handleCloseLoginModal || handleCloseRegModal) {
      if (getPackageInfo()) navigate('/pricing');
      else window.location.href = returnDashUrl();
      return;
    }
    setShowLogin(false);
    setShowRegistration(false);
  }, [handleCloseLoginModal, handleCloseRegModal, getPackageInfo, returnDashUrl]);

  const handleBackClick = useCallback(() => {
    setShowLogin(true);
    setShowForgotPassword(false);
  }, []);

  useEffect(() => {
    if (getNewUser()) {
      if (window.location.href.includes('hexofy.com')) {
        //@ts-ignore
        window.dataLayer = [];
        //@ts-ignore
        window.dataLayer.push({
          event: `accountRegistration-hexofy`,
          registrationOrderId: new Date().toISOString(),
        });
        //@ts-ignore
        window.dataLayer.push({
          event: `registration-hexofy`,
          ecommerce: {
            registration: {
              actionField: {
                id: `Registration_${new Date().toISOString()}`,
              },
            },
          },
        });
      }
      setNewUser(false);
    }
  }, []);

  return (
    <div className="content-wrap">
      <div className="content-wrapper-main">
        <Header refetchUser={() => getUser(true)} loading={loading} />
        {pageheroText && pageheroTitle && pageheroColor && (
          <PageHero text={pageheroText} title={pageheroTitle} color={pageheroColor} />
        )}
        <div className="page-wrapper">{children}</div>

        {showLogin && (
          <CustomModal setShowPopup={closeModal}>
            <Login
              setShowLogin={setShowLogin}
              setShowRegistration={setShowRegistration}
              setShowForgotPassword={setShowForgotPassword}
              setHandleCloseLoginModal={setHandleCloseLoginModal}
            />
          </CustomModal>
        )}
        {showRegistration && (
          <CustomModal setShowPopup={closeModal}>
            <Registration
              setShowLogin={setShowLogin}
              setShowRegistration={setShowRegistration}
              promoCode={promoCode.slice(0, promoCode.length - 1)}
              setHandleCloseRegModal={setHandleCloseRegModal}
            />
          </CustomModal>
        )}
        {showForgotPassword && (
          <CustomModal setShowPopup={setShowForgotPassword} showBackBtn onBackBtnClick={handleBackClick}>
            <ForgotPassword setShowForgotPassword={setShowForgotPassword} />
          </CustomModal>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default memo(Layout);
